import React, { useEffect } from "react";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Home Page/Footer";
import "./Disclaimer.css"; // Reuse the simple styling

const TermsOfUse = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <div className="container-fluid disclaimer-page posp-layout-padding">
                <div className="row">
                    <div className="col-12">
                        <h1>Terms of Use</h1>

                        <p><strong>Introduction</strong></p>
                        <p>
                            Vibe Insurance Broking and Advisory Services Private Limited (hereinafter referred to as “Vibe”) owns and operates the website <a href="https://policyengine.vibeins.com/">https://policyengine.vibeins.com/</a> to enable customers to explore, compare, and purchase insurance products offered by multiple insurers in a convenient and transparent manner.
                            Vibe is a licensed Insurance Broker holding a Direct Broking (Life & General) License issued by the Insurance Regulatory and Development Authority of India (IRDAI) vide License No. 904, Direct Broker Code No. IRDAI/DB1027/2023.
                            These Terms of Use (“Terms” or “Agreement”) govern your access to and use of this Website and its services. By accessing or using this Website, you acknowledge that you have read, understood, and agreed to be legally bound by these Terms.
                            Vibe reserves the right to revise or update these Terms at any time without prior notice. Your continued use of the Website constitutes acceptance of the revised Terms.
                        </p>

                        <p><strong>Responsible Use and Conduct</strong></p>
                        <p>
                            By using this Website, you agree: <br />
                            • To use the Website strictly for lawful purposes in compliance with applicable Indian laws and regulations <br />
                            • To provide true, accurate, and current information wherever required <br />
                            • To maintain confidentiality of login credentials and account details <br />
                            • Not to engage in unauthorized access, data mining, scraping, or automated access methods <br />
                            • Not to copy, reproduce, distribute, sell, or exploit Website content or services without authorization <br />
                            • To remain responsible for all activities conducted through your account <br />
                            • To use communication tools and interactions on the Website responsibly and ethically
                        </p>

                        <p><strong>Indemnity</strong></p>
                        <p>
                            You agree to indemnify and hold harmless Vibe, its directors, officers, employees, POSPs, partners, affiliates, and service providers (“Indemnified Parties”) against any claims, damages, liabilities, or expenses arising from: <br />
                            • Your breach of these Terms <br />
                            • Misuse of the Website <br />
                            • Violation of applicable laws or third-party rights <br />
                            Vibe reserves the right to assume exclusive defense and control of any matter subject to indemnification.
                        </p>

                        <p><strong>Limitation of Liability</strong></p>
                        <p>
                            To the maximum extent permitted by law, Vibe and its affiliates shall not be liable for any direct, indirect, incidental, consequential, or special damages, including loss of profits, data, goodwill, or business interruption arising from use of the Website.
                        </p>

                        <p><strong>Disclaimer of Warranty and Liability</strong></p>
                        <p>
                            • Information and services on this Website may contain inadvertent inaccuracies or typographical errors <br />
                            • Vibe disclaims liability for such errors and reserves the right to correct them at any time <br />
                            • All information and services are provided on an “AS IS” and “AS AVAILABLE” basis <br />
                            • Vibe does not warrant completeness, reliability, or suitability of insurance products for individual needs <br />
                            • Display of insurers or products does not constitute endorsement or recommendation
                        </p>

                        <p><strong>Third-Party Service Providers</strong></p>
                        <p>
                            Third-party service providers, insurers, and partners accessible through the Website operate independently. Vibe: <br />
                            • Is not responsible for their acts, omissions, or service deficiencies <br />
                            • Does not guarantee their performance or service levels <br />
                            • Shall not be liable for delays, cancellations, force majeure events, or governmental actions affecting services
                        </p>

                        <p><strong>Online Availability</strong></p>
                        <p>
                            Vibe does not guarantee uninterrupted or error-free Website availability. Access may be impacted by technical maintenance, system failures, or external factors beyond our control.
                        </p>

                        <p><strong>Modification of Terms</strong></p>
                        <p>
                            Vibe reserves the right to modify these Terms at any time. Users are encouraged to review them periodically. Continued use implies acceptance of revised Terms.
                        </p>

                        <p><strong>Intellectual Property Rights</strong></p>
                        <p>
                            All Website content, trademarks, logos, designs, and materials are the intellectual property of Vibe or respective owners.
                            Users may not: <br />
                            • Copy or reproduce content <br />
                            • Distribute or republish materials <br />
                            • Use content for commercial purposes <br />
                            without prior written consent.
                        </p>

                        <p><strong>Termination of Use</strong></p>
                        <p>
                            Vibe may suspend or terminate Website access without notice if: <br />
                            • These Terms are violated <br />
                            • Unlawful or fraudulent activity is suspected <br />
                            • User conduct is deemed harmful to Vibe or others <br />
                            Upon termination, all usage rights cease immediately.
                        </p>

                        <p><strong>Survival</strong></p>
                        <p>
                            Provisions relating to indemnity, limitation of liability, and intellectual property shall survive termination.
                        </p>

                        <p><strong>General Provisions</strong></p>
                        <p>
                            • If any provision is held unenforceable, remaining provisions remain valid <br />
                            • Failure to enforce any right does not constitute waiver <br />
                            • These Terms constitute the entire agreement between the user and Vibe <br />
                            • This Agreement is governed by the laws of India <br />
                            • Courts shall have exclusive jurisdiction over disputes
                        </p>

                        <p><strong>Acceptance of Terms</strong></p>
                        <p>
                            By accessing or using <a href="https://policyengine.vibeins.com/">https://policyengine.vibeins.com/</a>, you agree to these Terms of Use. If you do not agree, you must discontinue use immediately.
                            Continued use after updates constitutes acceptance of the revised Terms.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TermsOfUse;
